import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { scheduleInternalTxnOccurrences } from "../../../redux/features/scheduleInternalTxn";
import TransactionOccurrenceDetails from "../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";
import ScheduleTxnOccurrencesPopup from "../../ScheduleTransactions/ScheduleTxnOccurrencesPopup";
import "./index.css";
import Loader from "../../Loader/Index";

const ScheduleInternalTxnSelectFrequency = (props) => {
  const {
    txnPayLoad,
    setTxnPayLoad,
    openOccurrencesModal,
    setOpenOccurrencesModal,
  } = props;

  const slotData = [
    { value: "10:00 AM - 12:00 PM", label: "10:00 AM - 12:00 PM" },
    { value: "12:01 PM - 15:00 PM", label: "12:01 PM - 03:00 PM" },
    { value: "15:01 PM - 18:00 PM", label: "03:01 PM - 06:00 PM" },
  ];

  const dateRef = useRef(null);
  const dropdownRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const endDateRef = useRef(null);
  const slotdropdownRef = useRef();
  const yearDropdownRef = useRef(null);
  const services = useSelector((state) => state.refreshToken.services);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [slotdropdownOpen, setSlotDropdownOpen] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [SlotMappingData, setSlotMappingData] = useState(slotData || []);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);

  const parseToDateOrNull = (d) => {
    if (!d) return null;
    const candidate = new Date(d);
    return isNaN(candidate) ? null : candidate;
  };

  const [startDate, setStartDate] = useState(
    parseToDateOrNull(txnPayLoad?.transaction_start_date),
  );
  const [endDate, setEndDate] = useState(
    parseToDateOrNull(txnPayLoad?.transaction_end_date),
  );

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const frequencyOptions = [
    "Once",
    "Daily",
    "Weekly",
    "Fortnightly",
    "Monthly",
    "Quarterly",
    "Half yearly",
    "Yearly",
  ];

  const handleDateformat = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const handleFetchOccurence = async () => {
    const payloadObj = {
      frequency:
        txnPayLoad?.frequency === "Half yearly"
          ? "half_yearly"
          : (txnPayLoad?.frequency || "").toLowerCase(),
      transaction_start_date: handleDateformat(
        txnPayLoad?.transaction_start_date,
      ),
      transaction_end_date: handleDateformat(txnPayLoad?.transaction_end_date),
      navigate,
      services,
    };

    const data = await dispatch(scheduleInternalTxnOccurrences(payloadObj));

    setTxnPayLoad({
      ...txnPayLoad,
      occurrences: data?.payload?.occurrences,
    });

    setScheduleOccurrenceDates(data?.payload?.dates ?? []);
  };

  const handleConfirm = () => {
    const isToday =
      startDate &&
      new Date().getDate() === new Date(startDate).getDate() &&
      new Date().getMonth() === new Date(startDate).getMonth() &&
      new Date().getFullYear() === new Date(startDate).getFullYear();

    setSlotMappingData(
      isToday
        ? slotData.filter(
            (da) => Number(da.value.split(":")[0]) > new Date().getHours(),
          )
        : slotData,
    );

    setShowDatePicker(false);

    if (txnPayLoad?.frequency === "Once") {
      setTxnPayLoad({
        ...txnPayLoad,
        transaction_start_date: handleDateformat(startDate),
        transaction_end_date: handleDateformat(startDate),
        slot: "",
      });
    } else {
      setTxnPayLoad({
        ...txnPayLoad,
        transaction_start_date: handleDateformat(startDate),
        slot: "",
      });
    }
  };

  const handleCancel = () => {
    setShowDatePicker(false);
    setStartDate(null);
    setEndDate(null);
    setScheduleOccurrenceDates([]);

    setTxnPayLoad({
      ...txnPayLoad,
      transaction_start_date: null,
      transaction_end_date: null,
      occurrences: "",
    });
  };

  const handleEndConfirm = () => {
    setShowEndDatePicker(false);
    setTxnPayLoad({
      ...txnPayLoad,
      transaction_end_date: handleDateformat(endDate),
    });
  };

  const handleEndCancel = () => {
    setShowEndDatePicker(false);
    setStartDate(null);
    setEndDate(null);
    setScheduleOccurrenceDates([]);

    setTxnPayLoad({
      ...txnPayLoad,
      transaction_start_date: null,
      transaction_end_date: null,
      occurrences: "",
    });
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    return `${d.getDate()} ${d.toLocaleString("default", { month: "short" })}, ${d.getFullYear()}`;
  };

  const getEndDate = () => {
    if (!txnPayLoad?.transaction_start_date) return new Date();
    const base = new Date(txnPayLoad?.transaction_start_date);
    switch (txnPayLoad?.frequency) {
      case "Weekly":
        base.setDate(base.getDate() + 7);
        return base;
      case "Fortnightly":
        base.setDate(base.getDate() + 14);
        return base;
      case "Monthly":
        base.setMonth(base.getMonth() + 1);
        return base;
      case "Yearly":
        base.setFullYear(base.getFullYear() + 1);
        return base;
      case "Quarterly":
        base.setMonth(base.getMonth() + 3);
        return base;
      case "Half yearly":
        base.setMonth(base.getMonth() + 6);
        return base;
      default:
        base.setDate(base.getDate() + 1);
        return base;
    }
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
      if (
        slotdropdownRef.current &&
        !slotdropdownRef.current.contains(e.target)
      )
        setSlotDropdownOpen(false);
      if (dateRef.current && !dateRef.current.contains(e.target))
        setShowDatePicker(false);
      if (endDateRef.current && !endDateRef.current.contains(e.target))
        setShowEndDatePicker(false);
    }

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (startDate) handleConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate]);

  useEffect(() => {
    if (endDate) handleEndConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate]);

  useEffect(() => {
    const isToday =
      startDate &&
      new Date().getDate() === new Date(startDate).getDate() &&
      new Date().getMonth() === new Date(startDate).getMonth() &&
      new Date().getFullYear() === new Date(startDate).getFullYear();

    setSlotMappingData(
      isToday
        ? slotData.filter(
            (da) => Number(da.value.split(":")[0]) > new Date().getHours(),
          )
        : slotData,
    );

    if (
      txnPayLoad?.transaction_start_date &&
      txnPayLoad?.transaction_end_date &&
      txnPayLoad?.frequency
    ) {
      handleFetchOccurence();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    txnPayLoad?.transaction_start_date,
    txnPayLoad?.transaction_end_date,
    txnPayLoad?.frequency,
  ]);

  return (
    <>
      {props?.txnLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : (
        <div
          className={`w-width-full px-padding-md lg:px-padding-base pt-padding-lg pb-padding-xl lg:mb-margin-base mb-margin-xxl overflow-y`}
        >
          {openOccurrencesModal && (
            <>
              <ScheduleTxnOccurrencesPopup
                closeCallback={() => setOpenOccurrencesModal(false)}
                occurrences={scheduleOccurrenceDates}
              />
            </>
          )}

          <TransactionOccurrenceDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            SlotMappingData={SlotMappingData}
            frequencyOptions={frequencyOptions}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            showEndDatePicker={showEndDatePicker}
            setShowEndDatePicker={setShowEndDatePicker}
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
            slotdropdownOpen={slotdropdownOpen}
            setSlotDropdownOpen={setSlotDropdownOpen}
            dateRef={dateRef}
            endDateRef={endDateRef}
            yearDropdownRef={yearDropdownRef}
            formatDate={formatDate}
            handleDateChange={handleDateChange}
            handleEndDateChange={handleEndDateChange}
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
            handleEndConfirm={handleEndConfirm}
            handleEndCancel={handleEndCancel}
            getEndDate={getEndDate}
            weekdays={weekdays}
            months={months}
            setOpenOccurrencesModal={setOpenOccurrencesModal}
          />

          <div className="h-mobile-create-header w-width-full Qmd:hidden block mb-margin-xl lg:mb-margin-base"></div>
        </div>
      )}
    </>
  );
};

export default ScheduleInternalTxnSelectFrequency;
